import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Layout from './components/Layout';

// Lazy load pages for code splitting
const Dashboard = lazy(() => import('./pages/Dashboard'));
const PlayerProfile = lazy(() => import('./components/PlayerProfile'));
const Leaderboard = lazy(() => import('./pages/Leaderboard'));
const PlayerCompare = lazy(() => import('./pages/PlayerCompare'));
const StatsHistoryPage = lazy(() => import('./pages/StatsHistoryPage'));
const GainsPage = lazy(() => import('./pages/GainsPage'));
const OverviewPage = lazy(() => import('./pages/OverviewPage'));

// Loading component
const LoadingFallback = () => (
  <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
    <div>Loading...</div>
  </div>
);

function AppContent() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = async (query) => {
    try {
      // Try to resolve the search query and navigate to player profile
      const { statsAPI } = await import('./services/statsAPI');
      let result;
      
      try {
        result = await statsAPI.resolveUsername(query);
      } catch {
        try {
          result = await statsAPI.resolveUuid(query);
        } catch {
          alert('Player not found');
          return;
        }
      }
      
      navigate(`/players/${result.id || result.uuid}`);
      setSearchQuery('');
    } catch (error) {
      console.error('Search error:', error);
      alert('Search failed: ' + error.message);
    }
  };

  return (
    <div className="app">
      <Header 
        onSearch={handleSearch}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <div className="main-content">
        <Sidebar />
        <Layout>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/overview" element={<OverviewPage />} />
              <Route path="/players/:playerId" element={<PlayerProfile />} />
              <Route path="/leaderboards" element={<Leaderboard />} />
              <Route path="/compare" element={<PlayerCompare />} />
              <Route path="/stats-history" element={<StatsHistoryPage />} />
              <Route path="/gains" element={<GainsPage />} />
              <Route path="*" element={
                <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
                  <h1>404 - Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                </div>
              } />
            </Routes>
          </Suspense>
        </Layout>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router basename="/stats6">
      <AppContent />
    </Router>
  );
}

export default App;
